import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CoachingPage from "./pages/CoachingPage";
import { Toaster } from "./components/ui/sonner";
import { TarsAssistantProvider } from "./context/TarsAssistantContext";

const Portfolio = lazy(() => import("./pages/Portfolio"));
const ReviewPage = lazy(() => import("./pages/ReviewPage"));
const AdminReviewsPage = lazy(() => import("./pages/AdminReviewsPage"));

const PageFallback = () => <div className="min-h-screen bg-[#05070B]" />;

function App() {
  return (
    <div className="App">
      <TarsAssistantProvider>
        <BrowserRouter>
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route path="/" element={<Portfolio />} />
              <Route path="/cours-ia" element={<CoachingPage locale="fr" />} />
              <Route path="/ai-coaching" element={<CoachingPage locale="en" />} />
              <Route path="/review" element={<ReviewPage />} />
              <Route path="/admin/reviews" element={<AdminReviewsPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0D1117",
              border: "1px solid rgba(30,144,255,0.25)",
              color: "#F3F6FA",
            },
          }}
        />
      </TarsAssistantProvider>
    </div>
  );
}

export default App;
